// Note: Keep the enums Alphabetically Sorted
import {
  CommonAriaTo1DSPropertiesAvailable,
  CommonNorthStarUserBiProperties,
  ContextColumnsBase,
  PanelActionOutcome,
} from "@mwt/web-js-telemetry";
/**
 * The user action logged for BI purpose.
 */
export enum ActionScenario {
  ApproveIssueUrl = "approveIssueUrl",
  BannerAlert = "bannerAlert",
  CheckSmsPrivacyConsent = "checkSmsPrivacyConsent",
  CopyIntegrationRecord = "copyIntegrationRecord",
  CopyPatientJoinLink = "copyPatientJoinLink",
  CopyProviderJoinLink = "copyProviderJoinLink",
  StartInLobbyChatButtonClicked = "startInLobbyChatButtonClicked",
  DownloadHL7Certificate = "downloadHL7Certificate",
  EpicLogin = "epicLogin",
  FHIRUrlSelected = "appointmentsFHIRSelected",
  GeneratePhoneNumber = "generatePhoneNumber",
  IntegrationRecordMenu = "integrationRecordMenu",
  JoinButtonClicked = "joinButtonClicked",
  LinkPhoneNumber = "linkPhoneNumber",
  RedirectToMeetingLaunchUrl = "redirectToMeetingLaunchUrl",
  RedirectToTeamsUserSignIn = "redirectToTeamsUserSignIn",
  RemoveHL7Certificate = "removeHL7Certificate",
  RemoveIntegrationRecord = "removeIntegrationRecord",
  RemovePhoneNumber = "removePhoneNumber",
  RetryTeamsMeetingLaunch = "retryTeamsMeetingLaunch",
  SaveSmsNotificationSettings = "saveSmsNotificationSettings",
  SelectVendor = "selectVendor",
  SignOut = "signOut",
  SubmitIssuerUrl = "submitIssuerUrl",
  Test = "test",
  UncheckSmsPrivacyConsent = "uncheckSmsPrivacyConsent",
  UnlinkPhoneNumber = "unlinkPhoneNumber",
  UpdateIssuerUrl = "updateIssuerUrl",
  UploadHL7Certificate = "uploadHL7Certificate",
}

export enum ActionScenarioType {
  ConfigurationWizard = "ehrConfigurationWizard",
  EHRQueue = "ehrQueue",
  PatientLobby = "ehrPatientLobby",
  PractitionerSignIn = "ehrPractionerSignIn",
  Test = "ehrTest",
}

export enum PageName {
  AppointmentView = "appointmentView",
  ConfigWizard = "configWizard",
  DirectJoin = "directJoin",
  PatientLobby = "patientLobby",
  PractitionerSignIn = "practitionerSignIn",
}

export enum PanelType {
  ConfigurationWizard = "configurationWizard",
  ConfigurationWizardError = "configurationWizardError",
  EHRQueue = "ehrQueue",
  Login = "login",
  PageHeader = "pageHeader",
  PatientLobby = "patientLobby",
  PatientLobbyError = "patientLobbyError",
  PractitionerSignIn = "practitionerSignIn",
  SilentLogin = "silentLogin",
  Test = "test",
}

export enum DataBagStatus {
  Failure = "failure",
  Success = "success",
}

export enum EventType {
  NonUiEvent = "nonuievent",
  Scenario = "scenario",
  Trace = "trace",
  UserBI = "userbi",
  performance = "performance",
}

export enum CustomContextColumns {
  AppId = "App.Id",
  AppName = "App.Name",
  TenantId = "Tenant.Id",
}

export const ContextColumns = {
  ...ContextColumnsBase,
  ...CustomContextColumns,
};

enum ExtendedPanelActionOutcome {
  OpenModal = "openModal",
}

export const ExtendedPanelActionOutcomeType = {
  ...PanelActionOutcome,
  ...ExtendedPanelActionOutcome,
};

/**
 * Name of module clicked.
 * Note: Keep the enums Alphabetically Sorted
 */
export enum ModuleName {
  AppointmentViewFHIRUrlSelected = "appointmentsFHIRSelected",
  ApproveIssueUrlButton = "approveIssueUrlButton",
  CancelSmsNotificationSettingsButton = "cancelSmsNotificationSettingsButton",
  CloseGeneratePhoneNumberButton = "closeGeneratePhoneNumberButton",
  CloseSelectVendorButton = "closeSelectVendorButton",
  CopyIntegrationRecordButton = "copyIntegrationRecordButton",
  CopyPatientJoinLinkButton = "copyPatientJoinLinkButton",
  CopyProviderJoinLinkButton = "copyProviderJoinLinkButton",
  DismissBannerAlertButton = "dismissBannerAlertButton",
  DownloadHL7CertificateButton = "downloadHL7CertificateButton",
  EpicLoginButton = "epicLoginButton",
  GeneratePhoneNumberButton = "generatePhoneNumberButton",
  IntegrationRecordMenuItem = "integrationRecordMenuItem",
  JoinAppointmentButton = "joinAppointmentButton",
  LinkPhoneNumberButton = "linkPhoneNumberButton",
  LobbyChatButton = "LobbyChatButton",
  OpenGeneratePhoneNumberButton = "openGeneratePhoneNumberButton",
  OpenSelectVendorButton = "openSelectVendorButton",
  OpenSmsNotificationSettingsButton = "openSmsNotificationSettingsButton",
  PatientLobbyRetryButton = "patientLobbyRetryButton",
  PractitionerSignInButton = "practitionerSignInButton",
  RemoveHL7CertificateButton = "removeHL7CertificateButton",
  RemoveIntegrationRecordButton = "removeIntegrationRecordButton",
  RemovePhoneNumberButton = "removePhoneNumberButton",
  SaveSmsNotificationSettingsButton = "saveSmsNotificationSettingsButton",
  SelectVendorButton = "selectVendorButton",
  SelectVendorDropdown = "selectVendorDropdown",
  SignOutButton = "signOutButton",
  SmsPrivacyConsentCheckbox = "smsPrivacyConsentCheckbox",
  SubmitIssuerUrlButton = "submitIssuerUrlButton",
  Test = "test",
  UnlinkPhoneNumberButton = "unlinkPhoneNumberButton",
  UploadHL7CertificateButton = "uploadHL7CertificateButton",
}

/**
 * Summary of the module's content. Should not include any channel name or team name.
 * Note: Keep the enums Alphabetically Sorted
 */
export enum ModuleSummary {
  AppointmentViewFHIRUrlSelected = "Appointment View loaded for a FHIR URL.",
  ApproveIssueUrlButton = "Button to approve issuer URL and updating it in the tenant mapping.",
  CancelSmsNotificationSettingsButton = "Button to cancel changes to SMS notification settings",
  CloseGeneratePhoneNumberButton = "Button to close the generate phone number dialog",
  CloseSelectVendorButton = "Button to close the select vendor dialog",
  CopyIntegrationRecordButton = "Button to copy integration record context fields.",
  CopyPatientJoinLinkButton = "Button to copy the join link for a patient, and create if none exists.",
  CopyProviderJoinLinkButton = "Button to copy the join link for a provider, and create if none exists.",
  DismissBannerAlertButton = "Button to dismiss the alert.",
  DownloadHL7CertificateButton = "Button to download epic HL7 certificate.",
  EpicLoginButton = "Button to sign in as Epic user.",
  GeneratePhoneNumberButton = "Button to generate SMS number for a tenant to link to an integration record.",
  IntegrationRecordMenuItem = "Menu item to view integration record.",
  JoinAppointmentButton = "Button for provider to join meeting from appointment view.",
  LinkPhoneNumberButton = "Button to link a phone number from an integration record",
  LobbyChatButton = "Button to open a lobby chat, creating one if none yet exists.",
  OpenGeneratePhoneNumberButton = "Button to open the generate phone number dialog",
  OpenSelectVendorButton = "Button to open the select vendor dialog",
  OpenSmsNotificationSettingsButton = "Button to open the SMS notification settings panel",
  PatientLobbyRetryButton = "Retry button for polling launch meeting URL in patient lobby.",
  PractitionerSignInButton = "Sign button on the practioner sign in lobby page.",
  RemoveHL7CertificateButton = "Button to remove epic HL7 certificate.",
  RemoveIntegrationRecordButton = "Remove integration record button.",
  RemovePhoneNumberButton = "Button to remove SMS number for an integration record.",
  SaveSmsNotificationSettingsButton = "Button to save SMS notification settings",
  SelectVendorButton = "Button to confirm changing which vendor configuration is selected",
  SelectVendorDropdown = "Dropdown that initializes the configuration process for the selected vendor",
  SignOutButton = "Button to sign out from EHR connector app.",
  SmsPrivacyConsentCheckbox = "Checkbox for giving privacy consent for the SMS feature",
  SubmitIssuerUrlButton = "Button to submit issuer URL for creating tenant mapping.",
  UnlinkPhoneNumberButton = "Button to unlink a phone number from an integration record",
  UploadHL7CertificateButton = "Button to upload epic HL7 certificate.",
}

export enum TelemetryScenarioName {
  PageLoad = "pageLoad",
  Test = "test",
}

export enum TelemetryErrorStatus {
  Error = "error",
  NetworkError = "networkError",
}

export enum DataBagHttpColumns {
  // PascalCase to match Virtual Visits column name.
  DataBagCorrelationId = "DataBag.CorrelationId",
  DataBagErrorType = "DataBag.errorType",
  DataBagIsRetry = "DataBag.isRetry",
  DataBagIsSuccessful = "DataBag.isSuccessful",
  DataBagReason = "DataBag.reason",
  DataBagServiceUrl = "DataBag.serviceUrl",
  DataBagUrl = "DataBag.url",
  DatabBagErrorSubType = "DataBag.errorSubType",
}

export enum DataBagPageViewColumns {
  DataBagFCP = "DataBag.fcp",
  DataBagRefUri = "DataBag.refUri",
  DataBagUrl = "DataBag.url",
}

export interface CustomContextProperties
  extends Omit<
    CommonNorthStarUserBiProperties,
    CommonAriaTo1DSPropertiesAvailable
  > {
  [CustomContextColumns.AppId]: string;
  [CustomContextColumns.AppName]: string;
  [CustomContextColumns.TenantId]: string;
}
export enum PerformanceDataBagColumns {
  DataBagFP = "DataBag.fp",
  DataBagRenderTime = "DataBag.renderTime",
  DataBagNavigationType = "DataBag.navigationType",
  DataBagLCPStartTime = "DataBag.lcpStartTime",
  DataBagLCPRenderTime = "DataBag.lcpRenderTime",
  DataBagElement = "DataBag.element",
}
